import ProvideAll from './Provider';
import ApplicationRoutes, { AuthRoutes } from './Routes';
import { Api, AccountFrameLayout } from './Routes';
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/tooltip";
import './App.scss';
import { initializePDFJS } from "./Functions/ReactPDF";




function App() {
  if (/^\/(?:SignIn|Register|Account\/Login\/(?:ForgotPassword|Register|LogOff)|web-api)/gi.test(window.location.pathname))
    return <Api/>;
  else if (/^\/en-US\/Account\/Manage\/(?:SetPassword|ChangeEmail|ConfirmEmail)/gi.test(window.location.pathname))
    return <AccountFrameLayout />;
  else if (/^\/Account\/Login\/(?:ResetPassword|ResetPasswordConfirmation)/gi.test(window.location.pathname)) 
    return <AccountFrameLayout title="Create a new Password" link="/sign-in"/>;
  else if (/^\/en-US\/Account\/LogIn\/ConfirmEmail/gi.test(window.location.pathname)) 
    return <AccountFrameLayout title="Email Confirmed" redirect="/account-settings"/>;
  else {
    initializePDFJS();
    return (
      <div className="App">
        <ProvideAll>
          <AuthRoutes>
            <ApplicationRoutes/>
          </AuthRoutes>
        </ProvideAll>
      </div>
    );
  }
}

export default App;
